import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { getCheckout } from '..'
import { ConsumerLookupCohort } from '@afterpaytouch/portal-api/types'
import { ConvergenceRollout, ConvergenceUnavailable, ConvergenceAuthMethod, ConvergenceCashLogin } from '../../model'
import { evaluateCohort } from './helper'
import { Cohort } from '@afterpaytouch/portal-api'
import { PURGE } from 'redux-persist'

export interface ConvergenceState {
  cohort?: Cohort
  rollout: ConvergenceRollout
  loginMethod?: ConvergenceAuthMethod
  cashLoginEnabled?: ConvergenceCashLogin
  ldKey?: string
  hasSetThemeBefore: boolean
}

export const convergenceInitialState: ConvergenceState = {
  rollout: ConvergenceUnavailable.Unavailable,
  hasSetThemeBefore: false,
}

interface ConvergenceReadinessUpdate {
  rollout: ConvergenceRollout
  cohort?: Cohort | null
  ldKey?: string
  cashLogin?: ConvergenceCashLogin
}

const slice = createSlice({
  name: 'convergence',
  initialState: convergenceInitialState,
  reducers: {
    setLoginMethod(state: ConvergenceState, action: PayloadAction<ConvergenceAuthMethod>) {
      state.loginMethod = action.payload
    },
    setConvergenceReadiness(state: ConvergenceState, action: PayloadAction<ConvergenceReadinessUpdate>) {
      state.rollout = action.payload.rollout
      state.cohort = action.payload.cohort === null ? undefined : action.payload.cohort ?? state.cohort
      state.ldKey = action.payload.ldKey ?? state.ldKey
      state.cashLoginEnabled = action.payload.cashLogin ?? state.cashLoginEnabled
    },
    setCohort(state, action: PayloadAction<Cohort>) {
      state.cohort = action.payload
    },
    setHasSetThemeBefore(state, action: PayloadAction<boolean>) {
      state.hasSetThemeBefore = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCheckout.fulfilled, (state, action) => {
        if (typeof action.payload.consumerLookup !== 'undefined') {
          const { cashtag, cohort: lookUpCohort } = action.payload.consumerLookup
          const existing = lookUpCohort === ConsumerLookupCohort.existing_consumer
          const { cohort } = evaluateCohort(
            cashtag,
            existing,
            state.rollout,
            action.payload.consumer?.email ?? undefined,
            false,
            action.payload.merchant.id?.toString()
          )
          state.cohort = cohort
        }
      })
      .addCase(PURGE, () => convergenceInitialState)
  },
})

export const { setLoginMethod, setConvergenceReadiness, setCohort, setHasSetThemeBefore } = slice.actions

export default slice.reducer
